import { CollectionStatusEnum } from "@kanpla/api-contract";
import { cva } from "class-variance-authority";

export const collectionStatusBg = cva("transition-colors", {
  variants: {
    status: {
      [CollectionStatusEnum.NO_ORDERS]: "bg-interface-neutral-1",
      [CollectionStatusEnum.IN_PROGRESS]: "bg-interface-warning-1",
      [CollectionStatusEnum.COLLECTED]: "bg-interface-positive-1"
    }
  }
});

export const collectionStatusCardBg = cva("transition-colors", {
  variants: {
    status: {
      [CollectionStatusEnum.NO_ORDERS]: "bg-interface-neutral-0",
      [CollectionStatusEnum.IN_PROGRESS]: "bg-interface-warning-1",
      [CollectionStatusEnum.COLLECTED]: "bg-interface-positive-1"
    }
  }
});

export const collectionStatusIndicator = cva("", {
  variants: {
    status: {
      [CollectionStatusEnum.NO_ORDERS]: "bg-interface-neutral-4",
      [CollectionStatusEnum.IN_PROGRESS]: "bg-interface-warning-2",
      [CollectionStatusEnum.COLLECTED]: "bg-interface-positive-2"
    }
  }
});
